import React from "react";
import { useParams } from "react-router-dom";
import { useMount } from "react-use";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
import useAppContext from "../../../hooks/useAppContext";
import FullPageLoader from "../../../components/loaders/FullPageLoader";
import Section from "./Section";
import Attachment from "./Attachment";
import { wrapperClasses, stackColumnGap15, stackColumnGap5 } from "./Attachment/style";
import { OpenComparisonDocument } from "../../../components/UI/AttachmentOpenButton";

const ChangesSummary = () => {
  const params = useParams();
  const { getAttachment, initialLoading } = useAppContext();

  const { attachmentId } = params;
  const appInsights = useAppInsightsContext();
  const attachment = getAttachment(attachmentId);

  useMount(() => {
    appInsights.trackPageView({ name: "Changes summary" });
  });

  if (initialLoading) {
    return <FullPageLoader title="Analysis loading..." />;
  }

  return (
    <div className={`${wrapperClasses} ${stackColumnGap15}`}>
      <Attachment attachment={attachment} />
      <div className={stackColumnGap15}>
        {attachment.recognizedSegments.map((recognizedSegment, index) => {
          const isHeading = recognizedSegment.recognizedHeadings.length === 1 && recognizedSegment.recognizedSegment !== 'Main Numbering' && recognizedSegment.recognizedSegment !== 'Definitions';
          const segmentIndex = index;

          if (isHeading) {
            const segment = recognizedSegment.recognizedHeadings[0];

            return (
              <Section
                link={`/comparison-summary-detail/${attachmentId}/${segmentIndex}/0`}
                title={recognizedSegment.recognizedSegment}
                deleted={segment.characterCountDeleted}
                unchanged={segment.characterCountUnchanged}
                inserted={segment.characterCountInserted}
                isHeading={true}
                key={index}
              />
            );
          }
          return (
            <div key={index}>
              <div style={{ fontWeight: "bold" }}>{recognizedSegment.recognizedSegment}</div>
              <div className={stackColumnGap5}>
                {recognizedSegment.recognizedHeadings.map((segment, index) => {
                  return (
                    <Section
                      link={`/comparison-summary-detail/${attachmentId}/${segmentIndex}/${index}`}
                      key={index}
                      title={segment.recognizedHeading}
                      deleted={segment.characterCountDeleted}
                      unchanged={segment.characterCountUnchanged}
                      inserted={segment.characterCountInserted}
                      isHeading={false}
                    />

                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
       {/* To do: change this open document value from attachment comment so it works with savedAttachment when document document management enabled */}
      {attachment.attachmentComment.length > 0 ?  (
      <OpenComparisonDocument data={attachment.attachmentComment}/>
      ): null}
    </div>

  );
};

export default ChangesSummary;
